import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { useState } from 'react';
/**
 * Button-toggled disclosure for settings sections. The children are not
 * rendered at all while collapsed (not merely hidden), so an expensive
 * subtree — the PDF designer and its live preview — costs nothing until the
 * section is opened.
 */
export function CollapsibleSection({ title, description, defaultOpen = false, open: controlledOpen, onOpenChange, className, children, }) {
    const [uncontrolledOpen, setUncontrolledOpen] = useState(defaultOpen);
    const open = controlledOpen ?? uncontrolledOpen;
    const handleToggle = () => {
        const next = !open;
        if (controlledOpen === undefined)
            setUncontrolledOpen(next);
        onOpenChange?.(next);
    };
    return (_jsxs("div", { className: cn('space-y-3', className), children: [_jsxs("div", { children: [_jsxs("button", { type: "button", "aria-expanded": open, onClick: handleToggle, className: "text-foreground flex items-center gap-1.5 text-left text-sm font-medium pointer-coarse:min-h-11", children: [open ? (_jsx(ChevronDown, { className: "h-4 w-4 shrink-0" })) : (_jsx(ChevronRight, { className: "h-4 w-4 shrink-0" })), title] }), description ? _jsx("p", { className: "text-muted-foreground ml-6 text-xs", children: description }) : null] }), open ? _jsx("div", { className: "space-y-4", children: children }) : null] }));
}
